import React, { useContext } from 'react';
import {
   Nav, Tab,
} from 'react-bootstrap';
import { NavItem, NavLink, TabsWrap } from '@/shared/components/Tabs';
import Pending from './Pending';
import Confirm from './Confirmed';
import Past from './Past';
import Awaiting from './Awaiting';
import Rejected from './Rejected';
import { AuthContext } from '../../../../context/AuthContext';



const Tabs = () => {
  const { restaurantid } = useContext(AuthContext);
    
  return (
    <>
      {/* Tabs */}
      <Tab.Container defaultActiveKey="2" style={{ marginTop: '500px' }}>
        <TabsWrap>
          
          <Nav className="nav-tabs">
            <NavItem>
              <NavLink eventKey="1">Confirmed</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="2">Pending</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="3">Past</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="4">Awaiting</NavLink>
            </NavItem>
            <NavItem>
              <NavLink eventKey="5">Rejected </NavLink>
            </NavItem>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="1">
              <Confirm restaurantid={restaurantid} />
            </Tab.Pane>
            <Tab.Pane eventKey="2">
              <Pending restaurantid={restaurantid} />
            </Tab.Pane>
            <Tab.Pane eventKey="3">
              <Past restaurantid={restaurantid} />
            </Tab.Pane>
            <Tab.Pane eventKey="4">
              <Awaiting restaurantid={restaurantid} />
            </Tab.Pane>
            <Tab.Pane eventKey="5">
              <Rejected restaurantid={restaurantid} />
            </Tab.Pane>
          </Tab.Content>
        </TabsWrap>
      </Tab.Container>
    </>
  );
};

export default Tabs;
